import { createRouter, createWebHistory } from 'vue-router';
import Body from '@/components/body';
import Login from '@/auth/login.vue';
import { appName } from '@/constants/config';
import sessionService from '@/services/sessionService';

const employerChildren = [
  { path: '', redirect: '/dashboard' },
  { path: 'dashboard', name: 'dashboard', component: () => import('@/pages/admin/OperationalDashboardPage.vue'), meta: { title: `Dashboard | ${appName}` } },
  { path: 'hr-dashboard', name: 'hrDashboard', component: () => import('@/pages/admin/HrDashboardPage.vue'), meta: { title: `HR dashboard | ${appName}` } },
  { path: 'employees', name: 'employees', component: () => import('@/pages/admin/EmployeesPage.vue'), meta: { title: `Employees | ${appName}` } },
  { path: 'attendance', name: 'attendance', component: () => import('@/pages/admin/AttendancePage.vue'), meta: { title: `Attendance | ${appName}` } },
  { path: 'leave-approvals', name: 'leaveApprovals', component: () => import('@/pages/admin/LeaveApprovalsPage.vue'), meta: { title: `Leave approvals | ${appName}` } },
  { path: 'letter-requests', name: 'letterRequests', component: () => import('@/pages/admin/LetterRequestsPage.vue'), meta: { title: `Letter requests | ${appName}` } },
  { path: 'tasks', name: 'tasks', component: () => import('@/pages/admin/TasksPage.vue'), meta: { title: `Tasks | ${appName}` } },
  { path: 'locations', name: 'locations', component: () => import('@/pages/admin/LocationsPage.vue'), meta: { title: `Locations | ${appName}` } },
  { path: 'attendance-reports', name: 'attendanceReports', component: () => import('@/pages/admin/AttendanceReportsPage.vue'), meta: { title: `Attendance reports | ${appName}` } },
  { path: 'memos', name: 'memos', component: () => import('@/pages/admin/MemosPage.vue'), meta: { title: `Memos | ${appName}` } },
  { path: 'profile', name: 'profile', component: () => import('@/pages/admin/ProfilePage.vue'), meta: { title: `Profile | ${appName}` } },
  { path: 'settings/integrations', name: 'integrationSettings', component: () => import('@/pages/admin/IntegrationSettingsPage.vue'), meta: { title: `Integrations | ${appName}` } },
  { path: 'emiratisation', name: 'emiratisation', component: () => import('@/pages/admin/EmiratisationPage.vue'), meta: { title: `Emiratisation | ${appName}` } },
];

const routes = [
  { path: '/', component: Body, meta: { requiresEmployer: true }, children: employerChildren },
  { path: '/auth/login', name: 'login', component: Login, meta: { title: `Login | ${appName}`, guestOnly: true } },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach((to) => {
  const session = sessionService.getStoredSession();
  if (to.meta.requiresEmployer && !session) return { path: '/auth/login', query: { redirect: to.fullPath } };
  if (to.meta.guestOnly && session) return '/dashboard';
  document.title = to.meta.title || appName;
  return true;
});

export default router;
